import React from 'react';
import ApprovalWorkflowsForm from './ApprovalWorkflowsForm';
import './ApprovalWorkflows.css';
import {
    Box,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ApprovalWorkflowsModalProps {
    show: boolean;
    handleClose: (_: boolean) => void;
}

const ApprovalWorkflowsModal = ({
    show,
    handleClose,
}: ApprovalWorkflowsModalProps) => {
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            id="approval-workflows-modal"
            open={show}
            onClose={handleClose}
            data-testid="approval-workflows-modal"
            className="approval-workflow-modal">
            <DialogTitle data-testid="approval-workflows-modal-header">
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>Edit Approval Workflows</Box>
                    <Box>
                        <IconButton onClick={() => handleClose(true)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent className="ap-automation-approval-workflows-body">
                <ApprovalWorkflowsForm />
            </DialogContent>
        </Dialog>
    );
};

export default ApprovalWorkflowsModal;
